import styled from 'styled-components';

/* ============ Landing 2026 v2 — design system ============
   Fontes: 'Baloo 2' (títulos, gordinha e arredondada) + 'Nunito' (texto).
   Cores ancoradas no logo: roxo #7C4DD8, rosa #F2549D, amarelo #FFC93F,
   azul #4FA3E3, verde de ação #2FA95C. Texto em azul-marinho suave.  */

const INK = '#33305e';        // títulos
const CORPO = '#5c5a7a';      // texto corrido
const ROXO = '#7C4DD8';
const VERDE = '#2FA95C';
const CREME = '#FFF8EF';

export const Pagina = styled.div`
  font-family: 'Nunito', 'PT Sans', sans-serif;
  color: ${CORPO};
  background: #fff;

  h1, h2, h3 { font-family: 'Baloo 2', 'Nunito', sans-serif; }
`;

/* ---------- Barra do topo ---------- */
export const Barra = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  max-width: 1120px;
  margin: 0 auto;
`;

export const BarraLogo = styled.img`
  height: 46px;
  width: auto;
  @media (max-width: 767px) { height: 38px; }
`;

export const BarraEntrar = styled.button.attrs({ type: 'button' })`
  background: none;
  border: 2px solid #e3e0f0;
  border-radius: 50px;
  color: ${INK};
  font-family: 'Nunito', sans-serif;
  font-size: 15px;
  font-weight: 800;
  min-height: 44px;
  padding: 0 22px;
  cursor: pointer;
  touch-action: manipulation;
  &:hover { background: #f5f3fb; border-color: ${ROXO}; }
`;

/* ---------- Hero ---------- */
export const Hero = styled.section`
  background: linear-gradient(180deg, ${CREME} 0%, #FDEFDC 100%);
  padding: 24px 20px 44px;
`;

export const HeroConteudo = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 36px;
  @media (max-width: 900px) {
    /* Celular: a IMAGEM vem primeiro (acima do texto) */
    flex-direction: column-reverse;
    text-align: center;
    gap: 18px;
  }
`;

export const HeroTexto = styled.div`
  flex: 1;
`;

export const HeroChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #E5F6EA;
  color: #1e7a44;
  font-size: 14px;
  font-weight: 800;
  border-radius: 50px;
  padding: 8px 16px;
  margin-bottom: 16px;
`;

export const HeroTitulo = styled.h1`
  font-size: 42px;
  font-weight: 800;
  line-height: 1.12;
  color: ${INK};
  margin: 0 0 14px;
  letter-spacing: -0.3px;
  @media (max-width: 767px) { font-size: 30px; }
`;

export const HeroSub = styled.p`
  font-size: 19px;
  line-height: 1.55;
  margin: 0 0 22px;
  max-width: 520px;
  @media (max-width: 900px) { margin-left: auto; margin-right: auto; }
  @media (max-width: 767px) { font-size: 16.5px; }
`;

export const HeroImagem = styled.img`
  flex: 1;
  width: 100%;
  max-width: 470px;
  height: auto;
  border-radius: 28px;
  @media (max-width: 900px) { max-width: 320px; }
`;

export const HeroVideo = styled.video`
  flex: 1;
  width: 100%;
  max-width: 470px;
  height: auto;
  border-radius: 28px;
  @media (max-width: 900px) { max-width: 320px; }
`;

export const BotaoCTA = styled.button.attrs({ type: 'button' })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: ${VERDE};
  color: #fff;
  font-family: 'Baloo 2', 'Nunito', sans-serif;
  font-size: 20px;
  font-weight: 700;
  border: none;
  border-radius: 50px;
  min-height: 60px;
  padding: 0 36px;
  cursor: pointer;
  touch-action: manipulation;
  box-shadow: 0 6px 0 #23824a, 0 10px 22px rgba(47, 169, 92, 0.35);
  transition: transform 0.12s ease, box-shadow 0.12s ease;
  &:hover { transform: translateY(-2px); }
  &:active { transform: translateY(2px); box-shadow: 0 2px 0 #23824a; }
  @media (max-width: 767px) { width: 100%; font-size: 18px; }
`;

export const CTALegenda = styled.p`
  font-size: 14px;
  color: #8a87a3;
  margin: 12px 0 0;
`;

export const LinkSuave = styled.button.attrs({ type: 'button' })`
  background: none;
  border: none;
  color: ${ROXO};
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
  margin-top: 12px;
  padding: 8px;
  touch-action: manipulation;
`;

/* ---------- Barra de confiança ---------- */
export const Confianca = styled.div`
  background: #fff;
  border-bottom: 1px solid #f3f0e8;
  padding: 18px 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 14px 34px;
`;

export const ConfiancaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 15px;
  font-weight: 800;
  color: ${INK};
`;

/* ---------- Seções genéricas ---------- */
export const Secao = styled.section`
  padding: 60px 20px;
  background: ${(p) => p.fundo || '#fff'};
  @media (max-width: 767px) { padding: 42px 16px; }
`;

export const SecaoMiolo = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  text-align: center;
`;

export const SecaoTitulo = styled.h2`
  font-size: 34px;
  font-weight: 800;
  color: ${INK};
  margin: 0 0 10px;
  letter-spacing: -0.3px;
  @media (max-width: 767px) { font-size: 26px; }
`;

export const SecaoSub = styled.p`
  font-size: 17px;
  max-width: 640px;
  margin: 0 auto 36px;
`;

/* ---------- Como funciona ---------- */
export const Passos = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
`;

export const Passo = styled.div`
  flex: 1;
  min-width: 240px;
  max-width: 320px;
  background: ${CREME};
  border-radius: 24px;
  padding: 28px 22px;
`;

export const PassoNumero = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${(p) => p.cor || ROXO};
  color: #fff;
  font-family: 'Baloo 2', sans-serif;
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  box-shadow: 0 4px 0 rgba(0,0,0,0.12);
`;

export const PassoTitulo = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${INK};
  margin: 0 0 8px;
`;

export const PassoTexto = styled.p`
  font-size: 15px;
  line-height: 1.55;
  margin: 0;
`;

/* ---------- Vitrine ---------- */
export const Vitrine = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 560px) { grid-template-columns: 1fr; }
`;

export const VitrineCard = styled.div`
  background: #fff;
  border-radius: 24px;
  padding: 22px 20px;
  box-shadow: 0 4px 16px rgba(51, 48, 94, 0.08);
  text-align: center;
  transition: transform 0.15s ease;
  &:hover { transform: translateY(-4px); }
`;

export const VitrineImagem = styled.img`
  width: 100%;
  max-width: 210px;
  height: 128px;
  object-fit: contain;
  margin-bottom: 12px;
`;

export const VitrineTitulo = styled.h3`
  font-size: 19px;
  font-weight: 700;
  color: ${INK};
  margin: 0 0 6px;
`;

export const VitrineTexto = styled.p`
  font-size: 14.5px;
  line-height: 1.55;
  margin: 0;
`;

/* ---------- Família / valores ---------- */
export const Familia = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  max-width: 1000px;
  margin: 0 auto;
  text-align: left;
  @media (max-width: 900px) { flex-direction: column; text-align: center; }
`;

export const FamiliaImagem = styled.img`
  width: 100%;
  max-width: 420px;
  border-radius: 28px;
`;

export const FamiliaLista = styled.ul`
  list-style: none;
  padding: 0;
  margin: 16px 0 0;
  li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 16px;
    margin-bottom: 12px;
    line-height: 1.5;
    text-align: left;
    svg { margin-top: 2px; }
    b { color: ${INK}; }
  }
`;

/* ---------- Números ---------- */
export const Numeros = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px 52px;
`;

export const Numero = styled.div`
  text-align: center;
  b {
    display: block;
    font-family: 'Baloo 2', sans-serif;
    font-size: 40px;
    font-weight: 800;
    color: ${(p) => p.cor || ROXO};
    line-height: 1.1;
  }
  span { font-size: 15px; font-weight: 700; }
`;

/* ---------- Planos ---------- */
export const PlanosGrade = styled.div`
  display: flex;
  justify-content: center;
  gap: 26px;
  flex-wrap: wrap;
  align-items: stretch;
`;

export const PlanoCard = styled.div`
  background: #fff;
  border: ${(p) => (p.destaque ? `3px solid ${VERDE}` : '1px solid #ebe8f5')};
  border-radius: 26px;
  padding: 30px 26px;
  width: 330px;
  position: relative;
  box-shadow: 0 8px 24px rgba(51, 48, 94, 0.10);
  text-align: center;
`;

export const PlanoSelo = styled.div`
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  background: ${(p) => p.cor || VERDE};
  color: #fff;
  font-family: 'Baloo 2', sans-serif;
  font-size: 13.5px;
  font-weight: 700;
  border-radius: 50px;
  padding: 5px 18px;
  white-space: nowrap;
  letter-spacing: 0.4px;
`;

export const PlanoNome = styled.h3`
  font-size: 22px;
  font-weight: 700;
  color: ${INK};
  margin: 8px 0 4px;
`;

export const PlanoPreco = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: 40px;
  font-weight: 800;
  color: ${INK};
  small { font-size: 16px; font-weight: 600; color: #8a87a3; font-family: 'Nunito', sans-serif; }
`;

export const PlanoAncora = styled.div`
  font-size: 14px;
  color: ${VERDE};
  font-weight: 800;
  margin-bottom: 14px;
`;

export const PlanoRiscado = styled.div`
  font-size: 15px;
  color: #b9b6cc;
  text-decoration: line-through;
`;

export const PlanoLista = styled.ul`
  list-style: none;
  padding: 0;
  margin: 16px 0 22px;
  text-align: left;
  li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 14.5px;
    padding: 5px 0;
    line-height: 1.45;
    svg { margin-top: 1px; }
    b { color: ${INK}; }
  }
`;

/* ---------- FAQ ---------- */
export const FaqLista = styled.div`
  max-width: 680px;
  margin: 0 auto;
  text-align: left;
`;

export const FaqItem = styled.details`
  background: #fff;
  border: 1px solid #f0ede4;
  border-radius: 16px;
  margin-bottom: 12px;
  padding: 0 18px;

  summary {
    font-size: 16.5px;
    font-weight: 800;
    color: ${INK};
    padding: 16px 0;
    cursor: pointer;
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    &::after {
      content: '+';
      font-family: 'Baloo 2', sans-serif;
      font-size: 24px;
      color: ${ROXO};
      flex-shrink: 0;
    }
  }
  &[open] summary::after { content: '–'; }

  p {
    font-size: 15px;
    line-height: 1.6;
    margin: 0 0 16px;
    b { color: ${INK}; }
  }
`;

/* ---------- CTA final ---------- */
export const FinalWrap = styled.div`
  max-width: 760px;
  margin: 0 auto;
  text-align: center;
`;

export const FinalImagem = styled.img`
  width: 100%;
  max-width: 360px;
  border-radius: 28px;
  margin-bottom: 18px;
`;

/* ---------- Rodapé ---------- */
export const Rodape = styled.footer`
  background: #33305e;
  color: #cfcce4;
  padding: 38px 20px 30px;
  text-align: center;
`;

export const RodapeLogo = styled.img`
  height: 42px;
  margin-bottom: 14px;
`;

export const RodapeLinha = styled.p`
  font-size: 14.5px;
  margin: 4px 0;
  a { color: #b9a8f5; text-decoration: none; font-weight: 700; }
`;

export const RodapeMini = styled.p`
  font-size: 12.5px;
  color: #918fb0;
  margin-top: 18px;
`;
